import React from "react";
import { useSelector } from "react-redux";
import ScreenShareMirrorWarning from "../../Twilio/ScreenShare/ScreenShareMirrorWarning";
import OngoingScreenShareInfo from "../../Twilio/ScreenShare/OngoingScreenShareInfo";

const ScreenShare = () => {
    const { isScreenShareInfoOpen, isScreenShareMirrorWarningOpen } = useSelector((state) => state.twilioEvents);

    return (
        <>
            {/* Share screen information */}
            {isScreenShareMirrorWarningOpen && <ScreenShareMirrorWarning />}

            {/* Show message after share screen */}
            {isScreenShareInfoOpen && <OngoingScreenShareInfo />}
        </>
    );
};

export default ScreenShare;
